import { Star, Quote, ArrowUpRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const CREAM_DEEP = "#F0EBE0";
const INK = "#1A1F2E";
const INK_MUTED = "#5A6478";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
type Review = {
  name: string;
  suburb: string;
  service: string;
  date: string;
  rating: number;
  quote: string;
  initials: string;
};

// Featured (large) review
const FEATURED: Review = {
  name: "Sarah M.",
  suburb: "Bondi Junction",
  service: "B&D Roller — Spring & Cable",
  date: "April 2026",
  rating: 5,
  quote: "Our B&D roller door snapped a cable on a Sunday morning and we were stuck in the garage with school the next day. Called Gold Garage and they were here in 90 minutes. Replaced both springs and cables, tested everything, walked me through the work. Fixed price, no surprises. The door is quieter now than when it was new.",
  initials: "SM"
};

// Grid reviews
const REVIEWS: Review[] = [{
  name: "David K.",
  suburb: "Parramatta",
  service: "Merlin motor replacement",
  date: "March 2026",
  rating: 5,
  quote: "Old Merlin opener died after 14 years. Got 3 quotes — Gold wasn't the cheapest but was the most thorough on the phone. Glad I went with them. New motor, new remotes, took 2 hours. 12-month warranty in writing.",
  initials: "DK"
}, {
  name: "Priya R.",
  suburb: "North Sydney",
  service: "Off-track repair",
  date: "March 2026",
  rating: 5,
  quote: "Reversed into our roller door (don't ask). Two panels dented, off the tracks completely. They straightened the guide rails, replaced the slats, colour matched perfectly. Insurance covered it but they made the whole process painless.",
  initials: "PR"
}, {
  name: "Michael T.",
  suburb: "Hills District",
  service: "Annual service",
  date: "February 2026",
  rating: 5,
  quote: "Booked a tune-up after years of neglect. Door was making horrible noise. Technician was honest — said the door had life left in it, just needed lubrication and a spring re-tension. Could've sold me a whole new door. Didn't. Earned my trust.",
  initials: "MT"
}, {
  name: "Linda C.",
  suburb: "Sutherland",
  service: "Steel-Line curtain repair",
  date: "February 2026",
  rating: 5,
  quote: "Bottom slats of our Steel-Line door rusted through. They came, assessed it, ordered the matching slats, came back 3 days later and installed them. Looks brand new. Polite, on time, fairly priced.",
  initials: "LC"
}];
export default function RollerTestimonials() {
  return <section style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    padding: "120px 24px",
    fontFamily: FONT_BODY
  }}>
      {/* Watermark */}
      <div aria-hidden style={{
      position: "absolute",
      top: 60,
      right: -40,
      fontFamily: FONT_HEAD,
      fontSize: "clamp(160px, 20vw, 280px)",
      fontWeight: 900,
      color: CREAM_DEEP,
      opacity: 0.55,
      letterSpacing: "-0.04em",
      lineHeight: 1,
      pointerEvents: "none",
      userSelect: "none",
      zIndex: 0
    }}>
        REVIEWS
      </div>

      {/* Hairline rule */}
      <div aria-hidden style={{
      position: "absolute",
      top: 80,
      left: 24,
      width: 120,
      height: 1,
      background: GOLD,
      zIndex: 1
    }} />

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: 1200,
      margin: "0 auto"
    }}>
        {/* === HEADER === */}
        <div style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
        gap: 60,
        marginBottom: 64,
        alignItems: "end"
      }} className="roller-test-header">
          <div>
            <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 20
          }}>
              <span style={{
              fontFamily: FONT_BODY,
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: GOLD_DARK
            }}>
                07 / Sydney verdict
              </span>
              <span style={{
              width: 32,
              height: 1,
              background: GOLD
            }} />
            </div>

            <h2 style={{
            fontFamily: FONT_HEAD,
            fontSize: "clamp(34px, 4.5vw, 56px)",
            fontWeight: 800,
            color: INK,
            lineHeight: 1.05,
            letterSpacing: "-0.025em",
            margin: 0
          }}>
              The work speaks{" "}
              <span style={{
              color: GOLD_DARK,
              fontStyle: "italic",
              fontWeight: 700
            }}>
                for itself
              </span>
              <br />— our customers speak louder.
            </h2>
          </div>

          {/* Rating badge */}
          <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 16
        }} className="roller-test-badge-wrap">
            <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 14,
            padding: "16px 24px",
            background: "#ffffff",
            border: `1px solid ${CREAM_DEEP}`,
            borderRadius: 8,
            boxShadow: "0 4px 16px rgba(8,20,56,0.05)"
          }}>
              <div style={{
              display: "flex",
              gap: 2
            }}>
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} fill={GOLD} color={GOLD} strokeWidth={0} />)}
              </div>
              <div>
                <div style={{
                fontFamily: FONT_HEAD,
                fontSize: 22,
                fontWeight: 800,
                color: INK,
                lineHeight: 1,
                letterSpacing: "-0.01em"
              }}>
                  5.0
                </div>
                <div style={{
                fontFamily: FONT_BODY,
                fontSize: 11,
                fontWeight: 600,
                color: INK_MUTED,
                marginTop: 2
              }}>
                  100+ Google reviews
                </div>
              </div>
            </div>
            <div style={{
            fontFamily: FONT_BODY,
            fontSize: 13,
            color: INK_MUTED,
            fontStyle: "italic"
          }}>
              Every review verified by Google.
            </div>
          </div>
        </div>

        {/* === FEATURED REVIEW === */}
        <div style={{
        position: "relative",
        background: "#ffffff",
        border: `1px solid ${CREAM_DEEP}`,
        borderLeft: `4px solid ${GOLD}`,
        borderRadius: 4,
        padding: "48px 56px",
        marginBottom: 32,
        overflow: "hidden"
      }} className="roller-test-featured">
          {/* Large quote mark */}
          <Quote size={64} color={GOLD} strokeWidth={1.5} style={{
          position: "absolute",
          top: 32,
          right: 40,
          opacity: 0.15
        }} />

          <div style={{
          display: "grid",
          gridTemplateColumns: "auto minmax(0, 1fr)",
          gap: 40,
          alignItems: "start"
        }} className="roller-test-featured-grid">
            {/* Initials avatar */}
            <div style={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            background: NAVY,
            color: GOLD,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: FONT_HEAD,
            fontSize: 28,
            fontWeight: 800,
            letterSpacing: "0.02em",
            flexShrink: 0
          }}>
              {FEATURED.initials}
            </div>

            <div>
              {/* Stars */}
              <div style={{
              display: "flex",
              gap: 3,
              marginBottom: 20
            }}>
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} fill={GOLD} color={GOLD} strokeWidth={0} />)}
              </div>

              {/* Quote */}
              <blockquote style={{
              fontFamily: FONT_HEAD,
              fontSize: "clamp(20px, 1.9vw, 26px)",
              fontWeight: 500,
              color: INK,
              lineHeight: 1.45,
              letterSpacing: "-0.01em",
              margin: "0 0 32px",
              fontStyle: "italic"
            }}>
                "{FEATURED.quote}"
              </blockquote>

              {/* Author info */}
              <div style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 20,
              paddingTop: 24,
              borderTop: `1px solid ${CREAM_DEEP}`
            }}>
                <div>
                  <div style={{
                  fontFamily: FONT_HEAD,
                  fontSize: 17,
                  fontWeight: 800,
                  color: INK,
                  letterSpacing: "-0.005em"
                }}>
                    {FEATURED.name}
                  </div>
                  <div style={{
                  fontFamily: FONT_BODY,
                  fontSize: 13,
                  color: INK_MUTED,
                  marginTop: 4,
                  display: "flex",
                  alignItems: "center",
                  gap: 6
                }}>
                    <MapPin size={12} strokeWidth={2} />
                    {FEATURED.suburb}
                  </div>
                </div>
                <div style={{
                width: 1,
                height: 28,
                background: CREAM_DEEP
              }} />
                <div>
                  <div style={{
                  fontFamily: FONT_BODY,
                  fontSize: 10,
                  fontWeight: 800,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: GOLD_DARK,
                  marginBottom: 4
                }}>
                    Job completed
                  </div>
                  <div style={{
                  fontFamily: FONT_BODY,
                  fontSize: 14,
                  color: INK,
                  fontWeight: 500
                }}>
                    {FEATURED.service} · {FEATURED.date}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* === GRID OF 4 REVIEWS === */}
        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 20,
        marginBottom: 56
      }} className="roller-test-grid">
          {REVIEWS.map((r, i) => <ReviewCard key={i} review={r} />)}
        </div>

        {/* === BOTTOM CTA STRIP === */}
        <div style={{
        padding: "32px 40px",
        background: "#ffffff",
        border: `1px solid ${CREAM_DEEP}`,
        borderLeft: `3px solid ${GOLD}`,
        borderRadius: 4,
        display: "flex",
        flexWrap: "wrap",
        gap: 24,
        alignItems: "center",
        justifyContent: "space-between"
      }}>
          <div>
            <div style={{
            fontFamily: FONT_BODY,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: GOLD_DARK,
            marginBottom: 8
          }}>
              Read every review on Google
            </div>
            <div style={{
            fontFamily: FONT_HEAD,
            fontSize: 19,
            fontWeight: 600,
            color: INK,
            lineHeight: 1.3,
            letterSpacing: "-0.005em"
          }}>
              100+ verified reviews. No filters, no edits, no fake five stars.
            </div>
          </div>

          <a href="https://www.google.com/search?q=gold+garage+door+sydney+reviews" target="_blank" rel="noopener noreferrer" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "14px 22px",
          background: NAVY,
          color: "#ffffff",
          fontFamily: FONT_HEAD,
          fontSize: 14,
          fontWeight: 700,
          borderRadius: 8,
          textDecoration: "none",
          whiteSpace: "nowrap",
          transition: "background 0.2s, transform 0.2s"
        }} onMouseEnter={e => {
          e.currentTarget.style.background = NAVY_LIGHT;
          e.currentTarget.style.transform = "translateY(-2px)";
        }} onMouseLeave={e => {
          e.currentTarget.style.background = NAVY;
          e.currentTarget.style.transform = "translateY(0)";
        }}>
            View all Google reviews
            <ArrowUpRight size={16} strokeWidth={2.5} />
          </a>
        </div>
      </div>

      {/* Responsive */}
      <style>{`
        @media (max-width: 900px) {
          .roller-test-header {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
            align-items: start !important;
          }
          .roller-test-badge-wrap {
            align-items: flex-start !important;
          }
          .roller-test-featured {
            padding: 36px 28px !important;
          }
          .roller-test-featured-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .roller-test-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>;
}

// === Review Card ===
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <div className="roller-review-card" style={{
    position: "relative",
    padding: "32px 28px",
    background: "#ffffff",
    border: `1px solid ${CREAM_DEEP}`,
    borderRadius: 4,
    transition: "transform 0.2s, border-color 0.2s, box-shadow 0.2s",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    minHeight: 260
  }} onMouseEnter={e => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.borderColor = GOLD;
    e.currentTarget.style.boxShadow = "0 12px 32px rgba(8,20,56,0.08)";
  }} onMouseLeave={e => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.borderColor = CREAM_DEEP;
    e.currentTarget.style.boxShadow = "none";
  }}>
      {/* Top row */}
      <div style={{
      display: "flex",
      alignItems: "center",
      gap: 14,
      marginBottom: 18
    }}>
        <div style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        background: CREAM,
        border: `1px solid ${CREAM_DEEP}`,
        color: GOLD_DARK,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: FONT_HEAD,
        fontSize: 14,
        fontWeight: 800,
        letterSpacing: "0.02em",
        flexShrink: 0
      }}>
          {review.initials}
        </div>

        <div style={{
        flex: 1,
        minWidth: 0
      }}>
          <div style={{
          fontFamily: FONT_HEAD,
          fontSize: 15,
          fontWeight: 800,
          color: INK,
          letterSpacing: "-0.005em"
        }}>
            {review.name}
          </div>
          <div style={{
          fontFamily: FONT_BODY,
          fontSize: 12,
          color: INK_MUTED,
          marginTop: 2,
          display: "flex",
          alignItems: "center",
          gap: 4
        }}>
            <MapPin size={10} strokeWidth={2} />
            {review.suburb}
          </div>
        </div>

        <div style={{
        display: "flex",
        gap: 2
      }}>
          {[1, 2, 3, 4, 5].map(i => <Star key={i} size={12} fill={GOLD} color={GOLD} strokeWidth={0} />)}
        </div>
      </div>

      {/* Quote */}
      <p style={{
      fontFamily: FONT_BODY,
      fontSize: 14,
      color: INK,
      lineHeight: 1.6,
      margin: "0 0 20px",
      flex: 1
    }}>
        "{review.quote}"
      </p>

      {/* Footer */}
      <div style={{
      paddingTop: 16,
      borderTop: `1px solid ${CREAM_DEEP}`,
      display: "flex",
      flexWrap: "wrap",
      gap: 12,
      alignItems: "center",
      justifyContent: "space-between"
    }}>
        <div style={{
        fontFamily: FONT_BODY,
        fontSize: 12,
        color: INK_MUTED,
        fontWeight: 500
      }}>
          {review.service}
        </div>
        <div style={{
        fontFamily: FONT_BODY,
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: "0.15em",
        textTransform: "uppercase",
        color: GOLD_DARK
      }}>
          {review.date}
        </div>
      </div>
    </div>;
}